module.exports = __webpack_public_path__ + "static/media/cien-anos.9824fe1a.jpg";